import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { BackgroundTask } from "../../types/ai-event";

interface BackgroundTasksBarProps {
  tasks: BackgroundTask[];
  onStop: () => void;
}

// Shown above the composer while the chat's Claude Code session has Background Tasks running (spec
// 2026-10-27-claude-native-background-tasks, U3). Stop is user.interrupt: in a Hold the bridge stops the tasks.
export const BackgroundTasksBar: React.FC<BackgroundTasksBarProps> = ({ tasks, onStop }) => {
  const theme = useTheme();
  if (tasks.length === 0) return null;
  const label =
    tasks.length === 1
      ? `Background task running: ${tasks[0].description}`
      : `${tasks.length} background tasks running: ${tasks.map((t) => t.description).join(", ")}`;
  return (
    <Box
      data-testid="background-tasks-bar"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.5,
        py: 0.5,
        borderTop: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Typography variant="caption" sx={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {label}
      </Typography>
      <Button size="small" variant="outlined" color="error" onClick={onStop} data-testid="background-tasks-stop" sx={{ textTransform: "none" }}>
        Stop
      </Button>
    </Box>
  );
};
